<template>
  <d2-container>
    <div style="text-align: center; font-size: 17px">
      <el-table
        :data="tableData"
        :show-header="false"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="key"> </el-table-column>
        <el-table-column prop="value"> </el-table-column>
      </el-table>
    </div>

    <div style="text-align: center; margin-top: 15px">
      <el-button type="danger" @click="Audit" v-if="this.status == '未审核'"
        >审核驳回</el-button
      >
      <el-button
        style="margin-left: 20px"
        type="primary"
        @click="onSubmit"
        v-if="this.status == '未审核'"
        >审核通过</el-button
      >
    </div>
    <div v-if="this.status == '驳回'">
      <div class="overrule">驳回原因：</div>
      <div class="layout" style="margin-top: 10px">
        <!-- <div> -->
        <el-input
          type="textarea"
          :rows="5"
          v-model="auditMsg"
          readonly
        ></el-input>
        <!-- </div> -->
      </div>
    </div>
    <el-dialog
      v-if="dialogFormVisible"
      title="驳回原因"
      :visible.sync="dialogFormVisible"
      width="90%"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        :rows="5"
        v-model="auditmsg"
        maxlength="50"
        show-word-limit
      ></el-input>

      <div style="text-align: center; margin-top: 10px">
        <!-- <el-button @click="closeDialog">取消</el-button> -->
        <el-button type="primary" @click="bao">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
    >
      <span v-html="this.prompt"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { mapActions } from "vuex";
// import diaform from "./bo.vue";

export default {
  name: "index",
  // components: {
  //   diaform,
  // },
  data() {
    return {
      labelPosition: "right",
      dialogFormVisible: false,
      dialogVisible: false,
      groupId: "",
      // openid: "",
      // operate: "",
      auditmsg: "",
      auditMsg: "",
      priceApprovalid: 0,
      result: 0,
      status: "",
      update: "",
      prompt: "",
      tableData: [],
      // form: {
      //   areaName: "",
      //   thombTypeName: "",
      //   afterChangePrice: "",
      //   originalPrice: "",
      //   rowNo: "",
      //   columNo: "",
      //   changeType: 0,
      //   changeLevel:0,
      //   changeLevelname:'',
      // },
      rules: {},
    };
  },
  created() {
    this.feachdata();
  },
  methods: {
    ...mapActions("d2admin/adjustment", [
      "apijhiusersoperatePriceApproval",
      "apitombstombChangePriceByGroupId",
    ]),
    feachdata() {
      this.loading = this.$loading({
        fullscreen: true,
        text: "处理中",
        background: "rgba(0, 0, 0, 0.6)",
      });
      console.log("aa");
      const param = {
        groupId: this.$route.query.groupid,
      };
      console.log(param);
      this.apitombstombChangePriceByGroupId(param).then((res) => {
        console.log(res);
        this.tableData.push({
          key: "申请人",
          value: res.data.user.nickName,
        });
        this.tableData.push({
          key: "苑区",
          value: res.data.tomb.tombType.thombTypeName,
        });
        this.tableData.push({
          key: "区域",
          value: res.data.tomb.area.areaName,
        });
        this.tableData.push({ key: "几排", value: res.data.tomb.rowNo });
        if (res.data.changeType == 1) {
          this.tableData.push({ key: "墓位号", value: res.data.tomb.columNo });

          // this.form.originalPrice = res.data.originalPrice;
        } else {
          this.tableData.push({ key: "墓位号", value: "" });
        }

        if (res.data.changeLevel == 1 && res.data.changeType != 1) {
          this.tableData.push({ key: "调价级别", value: "墓型" });
        } else if (res.data.changeLevel == 2 && res.data.changeType != 1) {
          this.tableData.push({ key: "调价级别", value: "区域" });
        } else if (res.data.changeLevel == 3 && res.data.changeType != 1) {
          this.tableData.push({ key: "调价级别", value: "排" });
        } else {
          this.tableData.push({ key: "调价级别", value: "" });
        }
        if (res.data.changeType == 1) {
          this.tableData.push({ key: "标价", value: res.data.originalPrice });
          // this.form.originalPrice = res.data.originalPrice;
        } else {
          this.tableData.push({ key: "标价", value: "" });
        }
        if (res.data.changeType == 1) {
          this.tableData.push({ key: "底价", value: res.data.basePrice });
        } else {
          this.tableData.push({ key: "底价", value: "" });
        }
        this.tableData.push({
          key: "申请调整标价",
          value: res.data.afterChangePrice,
        });
        this.tableData.push({
          key: "申请调整底价",
          value: res.data.afterBasePrice,
        });
        console.log(res.data.auditState);

        if (res.data.auditState == 0) {
          this.status = "未审核";
        } else if (res.data.auditState == 1) {
          this.status = "已审核";
        } else if (res.data.auditState == 2) {
          this.status = "驳回";
        }

        this.tableData.push({ key: "状态", value: this.status });
        if (res.data.changeType == 2) {
          this.update = "是";
        } else {
          this.update = "否";
        }
        this.tableData.push({ key: "是否批量", value: this.update });
        this.auditMsg = res.data.auditMsg;
        // console.log(this.form);
        this.priceApprovalid = res.data.id;
        // this.openid = res.data.user.openId;
        this.loading.close();
      });
    },
    onSubmit() {
      this.loading = this.$loading({
        fullscreen: true,
        text: "处理中",
        background: "rgba(0, 0, 0, 0.6)",
      });
      const param = {
        priceApprovalId: this.priceApprovalid,
        openId: this.$route.query.openid,
        operate: "AGREE",
        auditMsg: this.auditmsg,
      };
      console.log(param);
      this.apijhiusersoperatePriceApproval(param)
        .then((res) => {
          this.prompt = res.data.msg;
          console.log(res);
          this.loading.close();
          this.dialogVisible = true;
          this.status = "已审核";
          this.tableData = [];
          this.feachdata();
        })
        .catch((err) => {});
    },
    Audit() {
      this.dialogFormVisible = true;
    },
    bao() {
      const param = {
        priceApprovalId: this.priceApprovalid,
        openId: this.$route.query.openid,
        operate: "REFUSE",
        auditMsg: this.auditmsg,
      };
      console.log(param);
      this.apijhiusersoperatePriceApproval(param).then((res) => {
        this.dialogFormVisible = false;
        this.prompt = res.data.msg;
        this.dialogVisible = true;
        // this.$alert(res.data.msg, "操作提示", {
        //       confirmButtonText: "确定",
        // });
        this.status = "驳回";
        this.tableData = [];
        this.feachdata();
      });
    },
    handleClose(done) {
      done();
    },
  },
};
</script>
<style  scoped>
.layout {
  width: 95%;
  margin: 10px;
  /* text-align: center; */
}
::v-deep .el-textarea__inner:focus {
  border-color: #dcdfe6 !important;
}
.overrule {
  margin-left: 10px;
}
</style>
